import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FEATURE_UNDER_CONSTRUCTION } from "configurations/MessageConstants";

const FeatureConstructionTooltip = ({ children, placement = "top" }) => {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={
        <Tooltip>
          <small style={{ fontSize: "10px" }}>
            {FEATURE_UNDER_CONSTRUCTION}
          </small>
        </Tooltip>
      }
    >
      <span>{children}</span>
    </OverlayTrigger>
  );
};

export default FeatureConstructionTooltip;
